import { EDITOR_TYPES, ObjectAnswer, UserAnswer } from '../robot.types';

export function convertToObjectAnswer(
    answer: UserAnswer,
    editor: EDITOR_TYPES.PYTHON | EDITOR_TYPES.LIGHT_PYTHON | EDITOR_TYPES.CODE_LIGHT_V2 = EDITOR_TYPES.PYTHON
): ObjectAnswer {
    if (typeof answer === 'string') {
        return {
            version: '1',
            answer: { editor, code: answer },
        };
    }

    return answer;
}
